import type { ITableHeader } from '../../../types/table/table_header';

import { TableHeader } from '../../Table/TableHeader';

import styles from './header.module.scss';

/**
 * The `DataTable`'s title area — a full-width wrapper around the shared
 * `TableHeader`, which carries the title, count, description and any actions.
 *
 * It exists so the table can control the header's width independently of the
 * primitive, and so the container has one child per region to hand props to.
 */
export const Header = (props: ITableHeader) => (
  <div className={styles['table-header']}>
    <TableHeader {...props} />
  </div>
);
